import styled, { keyframes, css } from "styled-components";

export const promoteLayer = css`
	will-change: transform;
`;

interface DropdownRootProps {
	$animatingOut?: boolean;
	$direction: string;
	$duration: number;
	$caretPosition?: "start" | "center" | "end";
}

const getDropdownRootKeyFrame = ({ $animatingOut, $direction }: Readonly<DropdownRootProps>) => {
	if (!$animatingOut && $direction) {
		return null;
	}
	return keyframes`
  from {
    transform: ${$animatingOut ? "rotateX(0)" : "rotateX(-15deg)"};
    opacity: ${$animatingOut ? 1 : 0};
  }
  to {
    transform: ${$animatingOut ? "rotateX(-15deg)" : "rotateX(0)"};
    opacity: ${$animatingOut ? 0 : 1};
  }
`;
};

export const DropdownRoot = styled.div<DropdownRootProps>`
	transform-origin: 0 0;
	${promoteLayer}
	animation-name: ${getDropdownRootKeyFrame};
	animation-duration: ${(props) => props.$duration}ms;
	/* use 'forwards' to prevent flicker on leave animation */
	animation-fill-mode: forwards;
	/* flex styles will center the caret child component */
	display: flex;
	flex-direction: column;
	align-items: ${(props) => props.$caretPosition ?? "center"};
	position: relative;
	top: 0px;
`;

export const DropdownBackground = styled.div`
	transform-origin: 0 0;
	background-color: white;
	border-top-left-radius: 0px;
	border-top-right-radius: 0px;
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
	overflow: hidden;
	position: relative;
	box-shadow: 0px 2px 5px #999999;
	width: 100%;
	${promoteLayer}
`;

export const AltBackground = styled.div<{ $duration: number }>`
	background-color: transparent;
	width: 100px;
	height: 100%;
	position: absolute;
	top: 0;
	left: -100%;
	transform-origin: 0 0;
	z-index: 0;
	transition: transform ${(props) => props.$duration}ms;
`;
